'use strict';

import getRolesDefinition from '../../../roles';

class SignupController {
    /* @ngInject */
    constructor(
        $scope,
        UsersService,
        PermRoleStore,
        $location
    ) {
        Object.assign(this, { UsersService, $location, PermRoleStore });
        this.invite = $scope.$parent.$resolve.invite;
        this.btnEnabled = false;
    }

    updateFormStatus() {
        let mustMatchValidity = !!(
            this.password
                && this.passwordConfirmation
                && this.password === this.passwordConfirmation
        );
        this.form.passwordConfirmation
            .$setValidity('mustMatch', mustMatchValidity);
    }

    doSignup() {
        this.updateFormStatus();
        if (!this.form.$valid) {
            return;
        }

        this.showSpin = true;
        this.btnEnabled = false;
        this.UsersService.signup({
            token: this.invite.token,
            inviteId: this.invite.id,
            password: this.password
        }).then(user => {
            return this.UsersService.login({
                email: this.invite.email,
                password: this.password
            });
        }).then(data => {
            this.PermRoleStore.defineManyRoles(
                getRolesDefinition(data.user)
            );
            console.debug('Redirecting to home.....');
            this.$location.url('/');
        }).catch(err => {
            // TODO: display error dialog
            console.error(err);
            this.btnEnabled = true;
            this.showSpin = false;
        });
    }
}

export default SignupController;
